import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService, Response } from '@tcc-mono/shared/data-access';
import { Stable, Veterinarian } from '@tcc-mono/vandijk/shared/data-access/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VeterinarianService extends BaseService<Veterinarian> {
  constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/veterinarians';
  }

  public getStables = (veterinarianId: number): Observable<Stable[]> => {
    return this.getChild<Response<Stable[]>>(veterinarianId, 'stables')
      .pipe(map((response: Response<Stable[]>) => response.data || []));
  };

  public attachStable = (veterinarianId: number, stableId: number): Observable<unknown> => {
    return this.postChild({ stable_id: stableId }, `${veterinarianId}/stables/attach`);
  };

  public detachStable = (veterinarianId: number, stableId: number): Observable<unknown> => {
    return this.postChild({ stable_id: stableId }, `${veterinarianId}/stables/detach`);
  };
}
